import Vue from "vue";
import { mapGetters } from "vuex";

Vue.component("start-component", {
  template: `<div class="c-start">
                
              <div class="c-start-banner">
                <h1 class="c-start-banner-title" v-html="activeView.title"></h1>
                <h2 class="c-start-banner-subtitle" v-if="activeView.sub"  v-html="activeView.sub"></h2>
              </div> 

              <div class="c-start-buttons">
                <a class="btn prominent btn-l3" v-on:click.stop.prevent="loginURL" href="#" >{{ activeView.btn_login }}</a>
                <a class="btn prominent btn-l2 ghost-btn"  v-on:click.stop.prevent="registrationURL" href="#">{{ activeView.btn_register }}</a>
              </div>

              <div style="padding:56.25% 0 0 0;position:relative; display: none">
                <iframe src="https://player.vimeo.com/video/269867331?autoplay=0&color=ffffff&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
              </div>
              
            </div>`,
  computed: {
    ...mapGetters({
      activeView: "activeView",
      host: "getHost",
      isMobile: "getIsMobile",
      isVanilla6: "getIsVanilla6",
      labels: "getLabels",
      language: "getLanguage"
    })
  },
  methods: {
    registrationURL() {
      const winHost = window.location.host;
      let langSegment = this.language;
      if (langSegment === "en_uk") {
        langSegment = "en";
      }
      if (this.isMobile) {
        window.location.href = `//${winHost.substring(
          6,
          winHost.length
        )}/${langSegment}/mobileportal/register?rurl=${encodeURIComponent(
          window.location.href
        )}`;
      } else {
        window.location.href = `//${winHost.replace(
          "promo",
          "www"
        )}/${langSegment}/registration`;
      }
      dataLayer.push({
        event: "Event.Functionality.",
        "page.referringAction": "coin-flip_Registration_Clicked"
      });
    },
    loginURL() {
      let langSegment = this.language;
      if (langSegment === "en_uk") {
        langSegment = "en";
      }

      if (this.isVanilla6) {
        window.location.href = `/${langSegment}/labelhost/login?rurl=${encodeURIComponent(
          window.location.href
        )}`;
      } 
      else {
        if (this.isMobile) {
          window.location.href = `/${langSegment}/mobilelogin/login?rurl=${encodeURIComponent(
            window.location.href
          )}`; 
        }  else {
          window.location.href = `/${langSegment}/authentication/login/index?ReturnUrl=${encodeURIComponent(
            window.location.href
          )}&IsEmbeddedPopUpPage=True`;
        }
      }

      dataLayer.push({
        event: "Event.Functionality.",
        "page.referringAction": "coin-flip_Login_Clicked"
      });
    }
  }
});



// WEBPACK FOOTER //
// ./app/js/components/start-component.js